'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Link;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _Links = require('./Links');

var _Links2 = _interopRequireDefault(_Links);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'link';

var getLinks = function getLinks() {
  var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (links && links.length) {
    return _react2.default.createElement(_Links2.default, {
      links: links
    });
  }

  return null;
};

function Link(_ref) {
  var label = _ref.label,
      href = _ref.href,
      linkIcon = _ref.linkIcon,
      links = _ref.links,
      onclick = _ref.onclick;

  var onClick = function onClick() {
    typeof onclick === 'string' ? eval(onclick) : onclick;
  };
  var iconStyle = require('shared/images/icons/icon-hold-coin.png');
  var imageStyle = linkIcon ? linkIcon : iconStyle;
  var linkContent = _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'em',
      null,
      _react2.default.createElement('img', { src: imageStyle, alt: '' })
    ),
    _react2.default.createElement(
      'span',
      null,
      label
    )
  );

  return _react2.default.createElement(
    'li',
    null,
    href.includes('http') ? _react2.default.createElement(
      'a',
      {
        href: href,
        className: CLASS_NAME,
        target: '_blank',
        onClick: onClick
      },
      linkContent
    ) : _react2.default.createElement(
      _reactRouter.Link,
      {
        to: href,
        className: CLASS_NAME
      },
      linkContent
    ),
    getLinks(links)
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Links/Link.jsx
// module id = 1082
// module chunks = 0